import React from "react";
import { connect } from "react-redux";
import * as r from "@/lib/backend/reports.generated.types";
import { DraggableConsumer } from "../../draggable/DraggableContext";
import { getShiftXPosition, getShiftWidth } from "../../reducers/gantt/properties";

import type { DraggableProviderContext } from "../../draggable/DraggableContext";
import type { ReduxState } from "../../reducers/reducers";

type OwnProps = {
    order_uuid: string;
    y: number;
    disabled_shifts: r.ISimulationReportOrderLineShiftFeatureItem[];
    material_title: string;
    is_dragging?: boolean;
    order_rect_stroke: number;
};

type Props = OwnProps & Partial<ReduxProps>;

class OrderDisabledShiftsClass extends React.Component<Props> {
    renderDisabledShifts = () => {
        const shift_x_positions = this.props.shift_x_positions;
        if (!shift_x_positions) {
            return null;
        }
        if (!this.props.disabled_shifts || this.props.disabled_shifts.length === 0) return null;
        const bar_height = this.props.bar_height || 0;
        const order_stroke = this.props.order_rect_stroke / 2;
        return this.props.disabled_shifts.map((shift, i) => {
            const shift_x = getShiftXPosition({
                shift_x_positions: shift_x_positions,
                shift_number: shift.shift_time.shift_number,
                week: shift.shift_time.week,
            });

            const x = shift_x;
            const width = this.props.xscale ? getShiftWidth(this.props.xscale) : undefined;

            return (
                <rect
                    key={`order-disabled-shift-${this.props.order_uuid}-${i}`}
                    id={"order-disabled-shift-" + this.props.order_uuid}
                    style={{ pointerEvents: "none" }}
                    x={(this.props.bars_start || 0) + x}
                    y={this.props.y + order_stroke}
                    width={width}
                    height={bar_height - 2 * order_stroke}
                    fill={"#ADB2BC"}
                    // @ts-ignore
                    material_title={this.props.material_title}
                />
            );
        });
    };

    render() {
        if (this.props.is_dragging) {
            return null;
        }
        return this.renderDisabledShifts();
    }
}

const mapState = (state: ReduxState) => {
    const properties = state.gantt_chart_properties;
    return {
        xscale: properties.xscale,
        bar_height: properties.bar_height,
        source_type: properties.source_type,
        shift_x_positions: properties.shift_x_positions,
        bars_start: properties.bars_start,
    };
};

type ReduxProps = ReturnType<typeof mapState>;

const ConnectedOrderDisabledShifts = connect<ReturnType<typeof mapState>, {}, OwnProps, ReduxState>(mapState)(
    OrderDisabledShiftsClass
);

const OrderDisabledShifts = (props: Props) => {
    return (
        <DraggableConsumer>
            {(value: DraggableProviderContext | null) => {
                if (!value) {
                    return null;
                }
                const is_dragging =
                    value.state.dragging_order && value.state.dragging_order.order_uuid === props.order_uuid;
                return <ConnectedOrderDisabledShifts is_dragging={is_dragging ?? false} {...props} />;
            }}
        </DraggableConsumer>
    );
};

export default OrderDisabledShifts;
